import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding":"0.22rem"} }

import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'leftTemplate5',
  props: {
  left_tabShow: String,
},
  emits: ['back'],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const clickclikc = ref('')
const menuList = ref([
  {
    name: '免责声明',
    value: 'mzsm'
  },
  {
    name: '社区指导原则',
    value: 'sqzdyz'
  },
]);
const props = __props;
onMounted(() => {
  clickclikc.value = props.left_tabShow ? props.left_tabShow : ''
})
const emit = __emit
//直接跳转
const selectcheck = (type: string) => {
  console.log("dianji ", type);
  clickclikc.value = type
  emit('back',clickclikc.value)
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", null, [
      _createElementVNode("div", { class: "left_title" }, "器材管理"),
      _createElementVNode("div", { class: "left_tab left_tab_select" }, " 发布的租赁信息 ")
    ], -1)
  ])))
}
}

})